module.exports = __webpack_public_path__ + "static/media/logo_login_2022.e0f44072.jpg";